import { JwtAxios } from '@/packaging';
export const buymaApi = {
  async GetBuymaApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetBuymaApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetBuymaApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetBuymaApiTemplate`, model);
    return responseModel;
  },
  async SetBuymaApi(body) {
    const responseModel = await JwtAxios.post('/Template/Market/SetBuymaApi', body);
    return responseModel;
  },
  // 인가 화면 URL (새 창으로 열어 판매자가 승인하면 토큰이 저장된다)
  async GetBuymaAuthorizeUrl(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetBuymaAuthorizeUrl?marketAccount=${marketAccount}`
    );
    return responseModel;
  }
};
